import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Spacer from '../../../../../../../../components/Spacer/Spacer';
import { Radio, Space } from 'antd';
import { createShallowCopy } from '../../../../../../../../utils/helpFunctions';
import SpecificReminders from './SpecificReminders';
import StandartReminders from './StandartReminders';
import { useDispatch, useSelector } from 'react-redux';
import {
    clientWelcomeReminders,
    deleteClientWelcomeReminder,
    getClientWelcomeReminders,
    oneClient,
    storeClientWelcomeReminders,
} from '../../../../../../../../redux/slices/clientsSlice';
import { toast } from 'react-toastify';

export default function WelcomeReminders() {
    const [data, setData] = useState({
        timings: [],
        isStandartFlow: true,
    });
    const mockTiming = useMemo(
        () => ({
            day: '3',
            templatePriority: [
                {
                    reminderName: 'welcome_reminder_email_1',
                    id: 1,
                },
            ],
        }),
        [],
    );

    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const clientReminders = useSelector(clientWelcomeReminders);

    useEffect(() => {
        const timings = clientReminders?.timings?.reduce((acc, el) => {
            const templatePriority = el.template_priority.map((priority) => ({
                reminderName: priority,
                id: priority.includes('sms')
                    ? Number(priority.slice(-1)) + 4
                    : Number(priority.slice(-1)),
            }));

            acc.push({
                id: el.id,
                day: el.day.toString(),
                name: el.name,
                communication_type: el.communication_type,
                templatePriority,
            });
            return acc;
        }, []);

        if (clientReminders?.use_default_wct !== undefined)
            setData({
                timings: !timings?.length ? [mockTiming] : timings,
                isStandartFlow: !!clientReminders?.use_default_wct,
            });
    }, [
        clientReminders?.timings,
        clientReminders?.use_default_wct,
        mockTiming,
    ]);

    const onRadioButtonsChange = (e) => {
        const dataCopy = createShallowCopy(data);

        dataCopy.isStandartFlow = e.target.value === 'standart';

        setData(dataCopy);
    };

    const onInputChange = (e, idx) => {
        const dataCopy = createShallowCopy(data);
        dataCopy.timings[idx].day = e.target.value;

        setData(dataCopy);
    };

    const onSelectChange = (option, idx, prioIndex) => {
        const dataCopy = createShallowCopy(data);
        dataCopy.timings[idx].templatePriority[prioIndex] = {
            reminderName: option.value,
            id: option.id,
        };
        setData(dataCopy);
    };

    const onAddReminder = (idx) => {
        const dataCopy = createShallowCopy(data);
        const haveEmailTiming = dataCopy.timings[idx].templatePriority.some(
            (el) => el.id < 5,
        );
        if (haveEmailTiming) {
            dataCopy.timings[idx].templatePriority.push({
                reminderName: 'welcome_reminder_sms_1',
                id: 5,
            });
        } else {
            dataCopy.timings[idx].templatePriority.push({
                reminderName: 'welcome_reminder_email_1',
                id: 1,
            });
        }

        setData(dataCopy);
    };

    const onDeleteReminder = (idx, reminderIndex) => {
        const dataCopy = createShallowCopy(data);

        dataCopy.timings[idx].templatePriority.splice(reminderIndex, 1);

        setData(dataCopy);
    };

    const onAddDay = () => {
        const dataCopy = createShallowCopy(data);

        dataCopy.timings.push({
            day: '3',
            templatePriority: [
                { reminderName: 'welcome_reminder_email_1', id: 1 },
            ],
        });

        setData(dataCopy);
    };

    const onRemoveDay = async (idx) => {
        const dataCopy = createShallowCopy(data);
        const timingId = dataCopy.timings[idx].id;

        dataCopy.timings.splice(idx, 1);

        if (timingId) {
            await dispatch(
                deleteClientWelcomeReminder({ id: client?.id, timingId }),
            ).unwrap();
            toast.success('Send out day successfully deleted');
        }
        setData(dataCopy);
    };

    const onSaveClientWelcomeReminders = async () => {
        if (data.isStandartFlow) setData({ timings: [], isStandartFlow: true });

        const timings = data.timings.map((el, i) => ({
            day: el.day,
            name: `welcome_reminder_${i + 1}`,
            communication_type: 'partner_specific',
            template_priority: el.templatePriority.map((el) => el.reminderName),
        }));
        const body = {
            timings: data.isStandartFlow ? [] : timings,
            use_default_wct: Number(data.isStandartFlow),
        };
        await dispatch(
            storeClientWelcomeReminders({ id: client?.id, body }),
        ).unwrap();

        toast.success('Changes saved successfully');
        dispatch(getClientWelcomeReminders(client?.id));
    };

    const specificRemindersProps = {
        data,
        onInputChange,
        onAddReminder,
        onDeleteReminder,
        onSelectChange,
        onAddDay,
        onRemoveDay,
    };

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - User communication - Timings - Welcome reminders`}</title>
            </Helmet>
            <Radio.Group
                onChange={onRadioButtonsChange}
                value={data.isStandartFlow ? 'standart' : 'specific'}
                name="emailFlow"
            >
                <Space direction="horizontal">
                    <Radio value="standart">Standart</Radio>
                    <Radio value="specific">Partner specific</Radio>
                </Space>
            </Radio.Group>
            <Spacer size={12} />
            {data?.isStandartFlow ? (
                <StandartReminders />
            ) : (
                <SpecificReminders {...specificRemindersProps} />
            )}
            <div className="form__footer">
                <button
                    className="modal__button modal__button-accept"
                    type="button"
                    onClick={onSaveClientWelcomeReminders}
                >
                    Save
                </button>
            </div>
        </div>
    );
}
